import './Sidebar.css';
import user48 from "../assets/images/user48.png";
import ReferenceButton from "./ReferenceButton";
import React, { useState, useEffect } from 'react';
import { UserService } from '../services/UserService.js'; 
import { useNavigate } from 'react-router-dom';

export default function Sidebar() {
 
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  
  useEffect(() => {
    const fetchUserProfile = async () => {
      const token = localStorage.getItem('accessToken');
 console.log(" Token trouvé dans localStorage ?", !!token);
      if (!token) {
        navigate('/login');
        return;
      }

      try {
        const userService = new UserService();
        const data = await userService.getCurrentUser(); 
          // VALIDATION STRICTE : Si un champ critique manque, on déclenche une erreur
        if (!data.prenom || !data.nom || !data.role) {
          throw new Error("Données utilisateur incomplètes ou corrompues reçues du serveur");
        }
        setUserData({
          prenom: data.prenom,
          nom: data.nom,
          role: data.role,
           avatar: data.avatar
        });
        setIsLoading(false);
          console.log("🟢 [Sidebar] Chargement réussi !");
      } catch (error) {
        console.error("Session expirée ou erreur critique:", error);
      
      }
    };

    fetchUserProfile();
  }, [navigate]);

  // 🟢 Écran de chargement sécurisé : rien ne s'affiche tant que l'identité n'est pas confirmée
  if (isLoading || !userData) {
    console.log("🟡 [Sidebar] Affichage de l'écran de chargement...");
    return (
      <div className="sidebar" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Vérification de la session...</p>
      </div>
    );
  }
 console.log("🟢 [Sidebar] Rendu final de la Sidebar avec :", userData.prenom);
  const fullName = `${userData.prenom} ${userData.nom}`.trim() || 'Utilisateur';
  const displayRole = userData.role === 'ADMIN' ? 'Administrateur' : (userData.role || 'Utilisateur');





  return (
    <div className="sidebar">

      <div className="userData">
         <div className="avatar">
          {/* 🟢 Affiche l'avatar de la BDD, ou l'image par défaut si vide */}
          <img 
            src={userData.avatar || user48} 
            alt="user avatar" 
            
          />
        </div>

        <div className="userInfo">
          {/* 🟢 Affichage dynamique du Nom et Prénom */}
          <div className="name">{fullName}</div>
          {/* 🟢 Affichage dynamique du Rôle */}
          <div className="role">{displayRole}</div>
        </div>
      </div>
      
      <div className="buttonPanel">
        <div className="buttonDiv">
          <ReferenceButton to={`/client_list`}>
             Clients
           </ReferenceButton>
           <ReferenceButton to={`/adresse_list_liv_client`}>
             Adresse Livraison Client
           </ReferenceButton>         
          <ReferenceButton to={`/fournisseur_list`}>
             Fournisseurs
           </ReferenceButton> 
          <ReferenceButton to={`/adresse_list_fournisseur`}>
             Adresses Fournisseurs
           </ReferenceButton>         
          <ReferenceButton to={`/product_list`}>
            Produits
           </ReferenceButton>         
          <ReferenceButton to={`/tva_list`}>
             TVA
           </ReferenceButton>
           <ReferenceButton to={`/tva-state-list`}>
             Pays TVA
           </ReferenceButton>
           <ReferenceButton to={`/contact_list`}>
             Contacts
           </ReferenceButton>
          <ReferenceButton to={`/dashboard_parametres`}>
             Paramétres
           </ReferenceButton>
           <ReferenceButton to={`/dashboard_maintenance`}>
             Maintenance
           </ReferenceButton>
        </div>
      </div>

       <div className="gptWindow">
        <div className="gptHeader">LocalGPT Assistant</div>
        <div className="gptBody">
          <p>👋 Bonjour ! Comment puis-je t'aider ?</p>
        </div>
        <div className="gptInput">
          <input type="text" placeholder="Ask something..." />
        </div>
      </div>
    </div>
  );
}